let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bJZpy"), load("5AfWB")]).then(() => parcelRequire('jubPE'));